import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import { DescRobot } from "./description-robot";
import { DescMech } from "./description-mechanism";
import { DescTool } from "./description-tool";
import { DescObject } from "./description-object";
import { DescStation } from "./description-station";


export const Description = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <>
            {
                props.data.hasOwnProperty('MT') && (props.data["MT"] == "R") &&
                <DescRobot
                    data={props.data}
                />
            }
            {
                props.data.hasOwnProperty('MT') && (props.data["MT"] == "E" || props.data["MT"] == "M") &&
                <DescMech
                    data={props.data}
                />
            }
            {
                props.data.hasOwnProperty('MT') && props.data["MT"] == "T" &&
                <DescTool
                    data={props.data}
                />
            }
            {
                props.data.hasOwnProperty('MT') && props.data["MT"] == "O" &&
                <DescObject
                    data={props.data}
                />
            }
            {
                props.type == "station" &&
                <DescStation
                    data={props.data}
                />
            }
        </>
    )
}